import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import JsonLd from "./JsonLd";
import { businessSchema, personSchema } from "../data/schema";

export default function Layout() {
  return (
    <>
      <JsonLd data={[businessSchema, personSchema]} />
      <Navbar />
      <main className="pt-20">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
